// AccessibilityManager ---------------------------------------	
function AccessibilityManager() {

	this.interact_objs = [];		// array of objects that are interactive
	this.view_scaling = 1;
	this.capt_size = 0;
	
	this.hasCaptions = false;

	// initializes the accessibility manager
	this.init = function() {
		// get the existing container div
		this.par_div = document.getElementById('content');
		// add accessibility div to container
		this.acc_div = document.createElement('div');
		this.acc_div.id = "access-div";
		this.par_div.appendChild(this.acc_div);	
		// add holder for screen-reader content
		this.srholder = document.createElement('div');
		this.srholder.id = "access-sr";
		this.acc_div.appendChild(this.srholder);	
		this.resetInteractiveContent();
		window.addEventListener('resize', this.resetInteractiveContent, true);
		// **** user testing listener
		window.addEventListener('keydown', this.UITestingKeypressHandler, false);	
	};
	
	// used for testing user interactions (mad*pow)
	this.UITestingKeypressHandler = function(event) {
		if (event.keyCode === 32) {
            window.parent.postMessage(event.keyCode, '*');
        }
	};

	// used to resize and reposition interactive content over the canvas
	this.resetInteractiveContent = function() {
		var ctr = 0,
			len = this.interact_objs.length;
		var pwid = this.par_div.offsetWidth,
			phgt = this.par_div.offsetHeight;
		this.view_scaling = this.par_div.offsetWidth / app.config.GAME.WIDTH;	
		this.acc_div.setAttribute('style', 'width:' + pwid.toString() + 'px;height:' + phgt.toString() + 'px;');
		this.acc_div.style.width = pwid.toString() + 'px';
		this.acc_div.style.height = phgt.toString() + 'px';
		// go through all of the children and update positions
		for(; ctr < len; ++ctr) {
			var btobj = this.interact_objs[ctr];
			btobj.adjustButtonParam(this.view_scaling);
		}
		// reposition captions if needed
		if(this.hasCaptions) {
			this.capt_obj.setAttribute('style', 'bottom:' + (this.capt_size * this.view_scaling).toString() + 'px !important');
		}
	};
	
	// used to set up the captions object and positioning
	this.setCaptionParameters = function(captid, captsz) {
		this.hasCaptions = true;
		this.capt_obj = document.getElementById(captid);
		this.capt_size = captsz;
		this.capt_obj.setAttribute('style', 'bottom:' + (this.capt_size * this.view_scaling).toString() + 'px !important');
	};
	
	// used to add interactive buttons to the accessibility div
	this.addInteractiveButton = function(newbt) {
		// set the parameters of the button
		newbt.adjustButtonParam(this.view_scaling);
		// add the button
		this.acc_div.appendChild(newbt.btn);
		this.interact_objs.push(newbt);
	};
	
	// used to remove all of the interactive buttons from the dom
	this.removeButtonsFromDOM = function() {
		while(this.interact_objs.length > 0) {
			var rmvbt = this.interact_objs[0];
			this.acc_div.removeChild(rmvbt.btn);
			this.interact_objs.splice(0, 1);
		}
	};
	
	// used to set the sr content for the dom
	this.setSRContent = function(srcont) {
		this.srholder.innerHTML = srcont;
	};
	
	// used to clear the sr content for the dom
	this.clearSRContent = function() {
		this.srholder.innerHTML = '';
	};
	
	// used to clear out the html interactive elements
	this.clearObjects = function() {
		this.interact_objs = null;	
	};

	this.resetInteractiveContent = this.resetInteractiveContent.bind(this);
	this.UITestingKeypressHandler = this.UITestingKeypressHandler.bind(this);
	
	this.init();
}

namespace('WGBH').AccessibilityManager = AccessibilityManager;
